import * as React from 'react';
import { ExpandMoreRounded, TwoWheelerRounded } from '@mui/icons-material';
import {
  SelectorCard,
  VehicleIcon,
  VehicleSelect,
  Caption,
  VehicleName,
  VehicleOption,
  OptionPlate,
} from './styles';

const plateOf = (vehicle) => vehicle?.Placa || vehicle?.placa;

const menuProps = {
  PaperProps: {
    sx: { mt: 1, borderRadius: 3, minWidth: 260 },
  },
};

function MapSelector({ vehicles, handleChange, selectedVehicle }) {
  const renderValue = (label) => {
    if (!label) {
      return (
        <>
          <Caption>Tu moto</Caption>
          <VehicleName>Cargando motos…</VehicleName>
        </>
      );
    }
    const plate = plateOf(vehicles.find((vehicle) => vehicle.label === label));
    return (
      <>
        <Caption>{plate ? `Tu moto · ${plate}` : 'Tu moto'}</Caption>
        <VehicleName>{label}</VehicleName>
      </>
    );
  };

  return (
    <SelectorCard>
      <VehicleIcon aria-hidden>
        <TwoWheelerRounded />
      </VehicleIcon>
      <VehicleSelect
        value={selectedVehicle || ''}
        onChange={handleChange}
        variant="standard"
        disableUnderline
        displayEmpty
        renderValue={renderValue}
        IconComponent={ExpandMoreRounded}
        MenuProps={menuProps}
        inputProps={{ 'aria-label': 'Elegir moto' }}
      >
        {vehicles.map((vehicle) => (
          <VehicleOption key={vehicle.value} value={vehicle.label}>
            {vehicle.label}
            {plateOf(vehicle) ? <OptionPlate>{plateOf(vehicle)}</OptionPlate> : null}
          </VehicleOption>
        ))}
      </VehicleSelect>
    </SelectorCard>
  );
}

export { MapSelector };
